import React, { useEffect, createElement } from 'react';
import { Routes, Route, Link, Navigate } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { FloatingPhone } from './components/FloatingPhone';
import { CookieConsent } from './components/CookieConsent';
import { Home } from './pages/Home';
import { OurServices } from './pages/OurServices';
import { BookingForm } from './pages/BookingForm';
import { HomeCleaningForm } from './pages/HomeCleaningForm';
import { DeepCleaningForm } from './pages/DeepCleaningForm';
import { MoveInOutForm } from './pages/MoveInOutForm';
import { PostRenovationForm } from './pages/PostRenovationForm';
import { AirbnbForm } from './pages/AirbnbForm';
import { AboutUs } from './pages/AboutUs';
import { ContactUs } from './pages/ContactUs';
import { FAQPage } from './pages/FAQPage';
export function App() {
  useEffect(() => {
    // Website schema
    const websiteScript = document.createElement('script');
    websiteScript.type = 'application/ld+json';
    websiteScript.id = 'ld-website';
    websiteScript.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'Smith & Jengs',
      url: window.location.origin
    });
    document.head.appendChild(websiteScript);
    // Organization schema
    const orgScript = document.createElement('script');
    orgScript.type = 'application/ld+json';
    orgScript.id = 'ld-organization';
    orgScript.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'Smith & Jengs',
      url: window.location.origin,
      logo: 'https://cdn.magicpatterns.com/uploads/jc63Wcs2z1JuqZfJSF71Nx/logo-white.png',
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: ['+441869601439', '+447432285564'],
        contactType: 'customer service',
        email: 'smithsandjengs@yahoo.com',
        areaServed: 'GB',
        availableLanguage: 'English'
      },
      sameAs: ['https://www.facebook.com/SmithandJengs/']
    });
    document.head.appendChild(orgScript);
    return () => {
      document.getElementById('ld-website')?.remove();
      document.getElementById('ld-organization')?.remove();
    };
  }, []);
  return <div className="min-h-screen w-full bg-light font-sans text-primary overflow-x-hidden" data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <Navbar data-id="element-2" />
      <Routes data-id="element-3">
        <Route path="/" element={<Home data-id="element-5" />} data-id="element-4" />
        <Route path="/services" element={<OurServices data-id="element-7" />} data-id="element-6" />
        <Route path="/book/commercial" element={<BookingForm data-id="element-9" />} data-id="element-8" />
        <Route path="/book/home-cleaning" element={<HomeCleaningForm data-id="element-11" />} data-id="element-10" />
        <Route path="/book/deep-cleaning" element={<DeepCleaningForm data-id="element-13" />} data-id="element-12" />
        <Route path="/book/move-in-out" element={<MoveInOutForm data-id="element-15" />} data-id="element-14" />
        <Route path="/book/post-renovation" element={<PostRenovationForm data-id="element-17" />} data-id="element-16" />
        <Route path="/book/airbnb" element={<AirbnbForm data-id="element-19" />} data-id="element-18" />
        <Route path="/book" element={<Navigate to="/services" replace data-id="element-21" />} data-id="element-20" />
        <Route path="/about" element={<AboutUs data-id="element-23" />} data-id="element-22" />
        <Route path="/contact" element={<ContactUs data-id="element-25" />} data-id="element-24" />
        <Route path="/faq" element={<FAQPage data-id="element-27" />} data-id="element-26" />
        <Route path="*" element={<main className="min-h-screen flex flex-col items-center justify-center bg-light text-center px-6 py-32" data-id="element-29">
              <h1 className="text-6xl md:text-8xl font-heading font-bold text-primary mb-4" data-id="element-30">
                404
              </h1>
              <p className="text-xl text-gray-600 mb-8" data-id="element-31">Page not found</p>
              <Link to="/" className="bg-accent hover:bg-accent/85 text-white font-bold tracking-wide px-8 py-4 rounded-lg transition-all" data-id="element-32">
                Back to home
              </Link>
            </main>} data-id="element-28" />
      </Routes>
      <Footer data-id="element-33" />
      <FloatingPhone data-id="element-34" />
      <CookieConsent data-id="element-35" />
    </div>;
}